/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![CalendarXIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABb0lEQVR4nN1VvUoDQRAOCGopioovY9orMj+nrDNB5XpLfYn4DuKbRNEg2NjEFL6AWpk6pIlM7lZjllySu4OAA8Mtu7PfN/Pt7G2ttioD1ick6VQV98fqSbKJrCNzG5eNG5tzbh1ZroHkw29a1oHlHVlbhhUQ2EJRYAy9FWpZInOcdtLPsAKSTlUEwPpY+38G1s+VnYGE96LCDhqZr5bAObft55nPd3KABkAyDOeln0swrzog/WpQ89g5txZF0UaDmhdGlhLqFVGyVY6A5Wg6psHNOuLJYQBcQKKBZT7eQ9IBlufIuV0fb2NgvUfWm9wsZ95SkqHJkhLoS1ZR14DNkfQ1u813hQiQdWSa2544PttDlp4n8eD2tbXCBMg6MM1/SDxwmvlbHJ8eBGeQ/cuXJogmZMklWO49kMvfA5VuNtfzctk3kCh90bQ1vxLp+z5HkrYHBNB9A/WEwPows2UXNWC9NaDJbFPJpG1rpQkWsW/BUmCf8SoWhAAAAABJRU5ErkJggg==)
 */
export const CalendarXIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15.3 15.3a1 1 0 0 1 1.4 0l2.3 2.29 2.3-2.3a1 1 0 0 1 1.4 1.42L20.42 19l2.3 2.3a1 1 0 0 1-1.42 1.4L19 20.42l-2.3 2.3a1 1 0 0 1-1.4-1.42L17.58 19l-2.3-2.3a1 1 0 0 1 0-1.4Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="m18.65 14.4-.53-.52a3 3 0 1 0-4.24 4.24l.52.53c.2.2.2.5 0 .7l-.52.53a2.99 2.99 0 0 0-.84 1.62c-.04.27-.26.5-.54.5H5a3 3 0 0 1-3-3v-9a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v2.5c0 .28-.23.5-.5.54-.6.1-1.16.38-1.62.84l-.53.52a.5.5 0 0 1-.7 0ZM5.5 12a.5.5 0 0 0-.5.5v3c0 .28.22.5.5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M7 1a1 1 0 0 1 1 1v.75c0 .14.11.25.25.25h7.5c.14 0 .25-.11.25-.25V2a1 1 0 1 1 2 0v.75c0 .14.11.25.25.25H19a3 3 0 0 1 3 3 1 1 0 0 1-1 1H3a1 1 0 0 1-1-1 3 3 0 0 1 3-3h.75c.14 0 .25-.11.25-.25V2a1 1 0 0 1 1-1Z"
        className={colorClass}
      />
    </svg>
  );
};
